import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { AutoPayTableRow, DatatableColumn } from '@amfam/billing/auto-pay/detail/models-util';

@Component({
  selector: 'ds-auto-pay-detail-table',
  templateUrl: './auto-pay-detail-table.component.html',
  styleUrls: ['./auto-pay-detail-table.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class AutoPayDetailTableComponent {
  @Input() tableRows: AutoPayTableRow[];
  @Input() tableColumns: DatatableColumn[];
  @Input() hideActions: boolean;

  constructor() {}
}
